import { defineStore } from 'pinia'

export const useWorkingHoursStore = defineStore('hours', {
    state: () => ({
        isWorkingHours: true
    }),
    actions: {
        updateWorkingHours() {
            const now = new Date()
            const day = now.getDay()
            const hour = now.getHours()
            const minute = now.getMinutes()
            const weekend = day === 0 || day === 6

            this.isWorkingHours = !(hour < 8 || hour > 18 || (hour === 8 && minute < 30 ) || (hour === 18 && minute >= 30 ));
            if (weekend) {
                this.isWorkingHours = false
            }
        }
    }
})